




/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";
// customerRegister
// CUSTOMERREGISTER
const GETALLFINANCECONSULTANTLISTFORAUTHUSER= createAsyncThunk(
  "getAllFinanceConsultantListForAuthUser/getAllFinanceConsultantListForAuthUser",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const getAllFinanceConsultantListForAuthUserSlice = createSlice({
  name: "getAllFinanceConsultantListForAuthUserSlice",
  initialState: {
    getAllFinanceConsultantListForAuthUser: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfgetAllFinanceConsultantListForAuthUser: (state) => {
        state.getAllFinanceConsultantListForAuthUser.loading = false
        state.getAllFinanceConsultantListForAuthUser.error = false
        state.getAllFinanceConsultantListForAuthUser.data = []
        state.getAllFinanceConsultantListForAuthUser.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(GETALLFINANCECONSULTANTLISTFORAUTHUSER.fulfilled, (state, action) => {
      state.getAllFinanceConsultantListForAuthUser = {
        ...state.getAllFinanceConsultantListForAuthUser,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETALLFINANCECONSULTANTLISTFORAUTHUSER.pending, (state, action) => {
      state.getAllFinanceConsultantListForAuthUser = {
        ...state.getAllFinanceConsultantListForAuthUser,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETALLFINANCECONSULTANTLISTFORAUTHUSER.rejected, (state, action) => {
      state.getAllFinanceConsultantListForAuthUser = {
        ...state.getAllFinanceConsultantListForAuthUser,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const getAllFinanceConsultantListForAuthUserAction = {
    GETALLFINANCECONSULTANTLISTFORAUTHUSER,
};

export { getAllFinanceConsultantListForAuthUserAction };
export default getAllFinanceConsultantListForAuthUserSlice.reducer;
export const {setInitialStateOfgetAllFinanceConsultantListForAuthUser} = getAllFinanceConsultantListForAuthUserSlice.actions
